import React from 'react';

import { useNavigate } from 'react-router-dom';

import Layout from '../components/common/Layout';
import TenantConfig from '../config';
import { sanitizeHtml } from '../helpers/format';

const FinishLater = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/review');
  };

  const handleExit = () => {
    navigate('/dashboard');
  };

  return (
    <Layout>
      <div className="finish-later-page">
        <div>
          <h1 className="title">Application Incomplete</h1>
          <h3>{TenantConfig?.finishLater.thankyouMsg}</h3>
          <div
            className="finish-later-details"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(TenantConfig?.finishLater.content),
            }}
          />

          <div className="button-groups d-flex">
            <div className="d-flex">
              <button className="outline-btn" onClick={handleExit}>
                Finish Later
              </button>
            </div>
            <button className="primary-btn" onClick={handleContinue}>
              Finish Application Now
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FinishLater;
